import React, { useState } from 'react'
import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { CloseIcon, StyledButton } from 'shared'
import { useOnboarding } from 'utils/providers/OnboardingProvider'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    bottom: 24,
    right: 24,
  },
  button: {
    borderRadius: 100,
    boxShadow: 'none',
    fontSize: 18,
    fontWeight: 500,

    '&:hover': {
      boxShadow: 'none',
    },
  },
  closeContainer: {
    position: 'absolute',
    top: '-12px',
    right: '-12px',
    width: 24,
    height: 24,
    backgroundColor: 'rgba(236, 236, 236, 0.50)',
    borderRadius: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeIcon: {
    width: 12,
    height: 12,
    color: 'black',
  },
  count: {
    height: 24,
    width: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.common.white,
    borderRadius: 100,
    color: theme.palette.error.main,
    fontSize: '14px !important',
    fontWeight: 600,
  },
}))

const OnboardingMobileButton = () => {
  const classes = useStyles()
  const { uncheckedSteps, onOpen } = useOnboarding()

  const [shown, setShown] = useState(true)

  if (!shown) return null

  return (
    <Grid className={classes.root}>
      <Grid position="relative">
        <StyledButton
          variant="contained"
          color="error"
          className={classes.button}
          endIcon={<Grid className={classes.count}>{uncheckedSteps}</Grid>}
          onClick={onOpen}
        >
          Onboarding
        </StyledButton>
        <Grid
          className={classes.closeContainer}
          onClick={() => setShown(false)}
        >
          <CloseIcon className={classes.closeIcon} />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default OnboardingMobileButton
